import { countriesWithExchangeRate } from "../../public/Constants/CountriesList";
import { create } from "zustand";
import { getCurrencies } from "../bigcommerce";
import { persist } from "zustand/middleware";
import { updateCartCurrency } from "../bigcommerce";
import useCartStore from "./useCartStore";
import { setCookie } from "cookies-next";
import { EXCHANGE_RATES } from "../../public/Constants/ExchangeRates";

const initialValues = {
    countriesRates: EXCHANGE_RATES,
    country: "United Arab Emirates",
    flag: "AE",
    currency: "AED",
    price: 109,
    exchangeRate: 1,
    countryDefaultValue: true,
    anonymusId: null,
    triggeredGeoIP2: false,
}

const useCountryStore = create(
    persist(
        (set, get) => ({
            ...initialValues,
            hasCountryHydrated: false,

            resetCountryStore() {
                console.log("resetCountryStore")
                set({ ...initialValues })
            },

            showCountrySelectionPopUp(boolean) {
                set({
                    triggeredGeoIP2: boolean,
                });
            },

            async changeCurrency({
                country,
                flag,
                currency,
                price,
                exchangeRate,
            }) {
                console.log("changeCurrency")
                set({ country, flag, currency, price, exchangeRate });
                if (get()?.countryDefaultValue) set({ countryDefaultValue: false })
                //this countryCode cookie use in nextauth do not remove !important
                setCookie("countryCode", flag);
                const cartId = useCartStore?.getState()?.cartId;
                if (cartId) {
                    try {
                        const updatedCartId = await updateCartCurrency(
                            cartId,
                            currency
                        );
                        useCartStore?.getState()?.setCartId(updatedCartId);
                    } catch (error) {
                        console.error("Error updating cart currency:", error);
                    }
                }
            },
            async getCountriesList() {
                try {
                    const { currenciesWithRate } = await getCurrencies();

                    if (
                        !currenciesWithRate ||
                        !Array.isArray(currenciesWithRate)
                    ) {
                        throw new Error("Invalid currenciesWithRate format");
                    }

                    const countries =
                        countriesWithExchangeRate(currenciesWithRate);
                    set({ countriesRates: countries });
                    return countries;
                } catch (error) {
                    console.error("Failed to fetch countries list:", error);
                }
            },

            setAnonymusId(anonymusId) {
                set({ anonymusId });
            },

            setHasHydrated: (state) => {
                set({
                    hasCountryHydrated: state,
                });
            },
        }),
        {
            name: "country-store", // key for local storage
            getStorage: () => localStorage,
            onRehydrateStorage: (state) => {
                return () => state.setHasHydrated(true);
            },
        }
    )
);

export default useCountryStore;
